var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-code"},[_c('canvas',{ref:"canvas",class:{downloadable: _vm.downloadable},on:{"click":_vm.onClicked}})])
}
var staticRenderFns = []

export { render, staticRenderFns }